import React from "react";
import UpcomingHolidays from "../UpcomingHolidays/UpcomingHolidays";

function EmployeeUpComingHolidays(props) {
  return <UpcomingHolidays />;
}

export default EmployeeUpComingHolidays;
